'use strict';

$(document).ready(function () {
    $('.faq-card').click(function () {
        if (!$(this).hasClass('active')) {
            $('.faq-card.active').removeClass('active');
            $(this).addClass('active');
        } else {
            $(this).removeClass('active');
        }
    });
});
